<template>
    <div class="tables-home">
        <div class="route-page-content">
            <SidebarChild
                :items="menuItems"
                :focusActive="true"
                @selected="handleSidebarSelection"
                :selectedItem="selectedItem"
                default-open
            />
            <TableList v-if="selectedItem === 'all-tables'" />
            <ModuleList v-if="selectedItem === 'modules'" mode="module" />
            <ModuleList v-if="selectedItem === 'relations'" mode="relation" />
            <TableSandbox v-if="selectedItem === 'sandbox'" />
        </div>
    </div>
</template>

<script>
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import TableList from "./TableList.vue";
import ModuleList from "../Modules/ModuleList.vue";
import TableSandbox from "./TableSandbox.vue";
import { mapActions } from "vuex";

export default {
    name: "TablesHome",
    components: {
        SidebarChild,
        TableList,
        ModuleList,
        TableSandbox,
    },
    data() {
        return {
            selectedItem: this.$route.query.type || "all-tables",
            menuItems: [
                {
                    enabled: true,
                    key: "all-tables",
                    label: this.$t("tables.allTables"),
                    icon: {
                        type: "material-icons",
                        name: "table_chart",
                    },
                },
                {
                    enabled: true,
                    key: "modules",
                    label: this.$t("modules.modules"),
                    icon: {
                        type: "material-icons",
                        name: "extension",
                    },
                },
                {
                    enabled: true,
                    key: "relations",
                    label: this.$t("modules.relations"),
                    icon: {
                        type: "material-icons",
                        name: "hub",
                    },
                },
                {
                    enabled: true,
                    key: "sandbox",
                    label: this.$t("tables.trashBin"),
                    icon: {
                        type: "material-icons",
                        name: "delete"
                    },
                },
                // {
                //     enabled: true,
                //     key: "favorites",
                //     label: this.$t("tables.myFavorites"),
                //     icon: {
                //         type: "material-icons",
                //         name: "star",
                //     },
                // },
            ],
        };
    },
    methods: {
        ...mapActions({
            syncTables: "table/syncTables",
        }),
        handleSidebarSelection(item) {
            console.log("Seçilen menü öğesi:", item.key);
            this.selectedItem = item.key;
            //add query param to route
            this.$router.push({
                query: {
                    type: item.key,
                },
            });
        },
    },
    created() {
        // TablesHome ilk yüklendiğinde bir kere sync yap
        // TableList created'da da sync yapacak ama bu ilk sync çok hızlı olacak
        this.syncTables(0);
    },
};
</script>

<style scoped lang="scss">
.tables-home {
    height: 100%;
}
</style>
